import { get, flatten } from 'lodash'

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const getConfig = (key) => {
  // eslint-disable-next-line no-undef
  return key ? get(env, key) : env
}

export const getContent = (slug, categoryContent) => {
  const mergeContent = flatten(categoryContent)
  if (slug.category && slug.topic && slug.article) {
    const category = mergeContent.find((v) => v.slug === slug.category)
    const topic = category?.submenu?.find((v) => v.slug === slug.topic)
    const article = topic?.article?.find((v) => v.slug === slug.article)
    return {
      content: get(article, 'description', ''),
      slugArray: [
        { label: get(category, 'title', ''), slug: get(category, 'slug', '') },
        { label: get(topic, 'label', ''), slug: get(topic, 'slug', '') },
        { label: get(article, 'label', ''), slug: get(article, 'slug', '') },
      ],
    }
  } else if (slug.category && slug.article) {
    const category = mergeContent.find((v) => v.slug === slug.category)
    const article = category?.submenu?.find((v) => v.slug === slug.article)
    return {
      content: get(article, 'description', ''),
      slugArray: [
        { label: get(category, 'title', ''), slug: get(category, 'slug', '') },
        { label: get(article, 'label', ''), slug: get(article, 'slug', '') },
      ],
    }
  } else if (slug.article) {
    const category = mergeContent.find((v) => v.slug === slug.article)
    const submenu = get(category, 'submenu', [])
    return {
      content: get(category, 'description', ''),
      slugArray: [{ label: get(category, 'title', ''), slug: get(category, 'slug', '') }],
      submenu,
    }
  }
}
